import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type UserRole = "registered" | "admin" | "user" | "guest";

export interface LoginState {
	username: string;
	email: string;
	uid: string;
	isAuth: boolean;
	type: UserRole | null;
	error: string | null;
}

const initialState: LoginState = {
	username: "",
	email: "",
	uid: "",
	isAuth: false,
	type: null,
	error: null,
};

interface LoginSuccessPayload {
	username: string;
	email: string;
	uid: string;
	type?: UserRole;
}

interface LoginFailurePayload {
	error: string;
}

const loginSlice = createSlice({
	name: "login",
	initialState,
	reducers: {
		login: (state) => {
			state.isAuth = true;
			state.error = null;
		},
		loginSuccess: (state, action: PayloadAction<LoginSuccessPayload>) => {
			state.username = action.payload.username;
			state.email = action.payload.email;
			state.uid = action.payload.uid;
			state.type = action.payload.type ?? "user";
			state.isAuth = true;
			state.error = null;
		},
		loginFailure: (state, action: PayloadAction<LoginFailurePayload>) => {
			state.isAuth = false;
			state.error = action.payload.error;
		},
		logoutUser: (state) => {
			state.username = "";
			state.email = "";
			state.uid = "";
			state.isAuth = false;
			state.type = null;
			state.error = null;
		},
	},
});

export const { login, loginSuccess, loginFailure, logoutUser } =
	loginSlice.actions;
export default loginSlice.reducer;
